export const DEFAULT_KEY = '_default_';
